module.exports = __webpack_public_path__ + "static/media/DSCF0033.16130ec6.jpg";